/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

import { getEnvs } from 'state/EnvironmentsContext/EnvContext';
import { DynamicField } from './useDynamicFields';

// Field label overrides for dynamic fields
export const FIELD_LABEL_OVERRIDES: Record<string, string> = {
  'document_type': 'Passport Type',
  'document_number': 'Passport Number',
  'document_issuing_authority': 'Issuing Authority',
  'document_expiration_date': 'Expiration Date',
};

// Helper function to check if field is a prefix field
export const isPrefixField = (field: DynamicField, fieldKey: string): boolean => {
  return (
    (typeof field.key === 'string' && field.key === 'prefix') ||
    field.label?.toLowerCase().includes('prefix')
  );
};

// Helper function to get the display label for a field
export const getFieldDisplayLabel = (field: DynamicField, fieldKey: string): string => {
  const isSportico = getEnvs(state => state.event) === "SPORTICO";
  if ((isPrefixField(field, fieldKey) && isSportico)) {
    return "Honorific";
  }
  if (FIELD_LABEL_OVERRIDES[fieldKey]) {
    return FIELD_LABEL_OVERRIDES[fieldKey];
  }
  
  if (typeof field.key === 'string' && FIELD_LABEL_OVERRIDES[field.key]) {
    return FIELD_LABEL_OVERRIDES[field.key];
  }
  
  return field.label;
};
